import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';

export default class GameScreenKeyControls extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.btnLeft = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._md_assets_ArrowRight, this).setOrigin(0)
      .setInteractive();
    this.btnLeft.scaleX = -1;
    this.btnLeft.x = this.btnLeft.width + 20;
    this.btnLeft.y = this.scene.scale.height / 2 - this.btnLeft.height / 2;
    this.btnLeft.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.buttonPressed(this.btnLeft, gameData.KEY_LEFT));
    this.btnLeft.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, () => this.buttonRelease(this.btnLeft));
    this.btnLeft.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, (pointer) => { if (pointer.isDown) this.buttonRelease(this.btnLeft); });

    this.btnRight = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._md_assets_ArrowRight, this).setOrigin(0)
      .setInteractive();
    this.btnRight.x = this.scene.scale.width - this.btnRight.width - 20;
    this.btnRight.y = this.scene.scale.height / 2 - this.btnRight.height / 2;
    this.btnRight.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.buttonPressed(this.btnRight, gameData.KEY_RIGHT), this);
    this.btnRight.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP,() => this.buttonRelease(this.btnRight));
    this.btnRight.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT,(pointer) => {if (pointer.isDown) this.buttonRelease(this.btnRight);});
  }

  /**
   * 
   * @param {Phaser.GameObjects.Image} button 
   * @param {number} key 
   */
  buttonPressed(button, key) {
    button.setFrame(UIAssetKeys._md_assets_ArrowOn).setOrigin(0);
    this.emit('CONTROL_INPUT', key);
  }

  /**
   * 
   * @param {Phaser.GameObjects.Image} button 
   */
  buttonRelease (button) {
    button.setFrame(UIAssetKeys._md_assets_ArrowRight).setOrigin(0);

    this.emit('CONTROL_INPUT', 'STOP_PENGUIN');
  }
}